"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedInSquare = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var LinkedInSquare = function LinkedInSquare() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.667 0h18.666A2.667 2.667 0 0124 2.667v18.666A2.667 2.667 0 0121.333 24H2.667A2.667 2.667 0 010 21.333V2.667A2.667 2.667 0 012.667 0zm4 20a.667.667 0 00.666-.667V10a.667.667 0 00-.666-.667h-2A.667.667 0 004 10v9.333c0 .369.298.667.667.667h2zm-1-12a2 2 0 110-4 2 2 0 010 4zm13.666 12a.667.667 0 00.667-.667V13.2a4.133 4.133 0 00-3.627-4.187 4 4 0 00-3.706 1.787V10A.667.667 0 0012 9.333h-2a.667.667 0 00-.667.667v9.333c0 .369.299.667.667.667h2a.667.667 0 00.667-.667v-5a2 2 0 014 0v5c0 .369.298.667.666.667h2z",
    clipRule: "evenodd"
  });
};

exports.LinkedInSquare = LinkedInSquare;